import { useI18n } from '../contexts/I18nContext';
import LogoImage from '../assets/1.png';

export default function Footer() {
  const { t, isRTL } = useI18n();

  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/share/1ARHdf7rwv/?mibextid=wwXIfr',
      iconPath: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/nassertravel5?igsh=d3Y4bnJvaTRsMXZq&utm_source=qr',
      iconPath: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
    },
  ];

  return (
    <footer className="relative w-full bg-gradient-to-b from-white to-[#FAFAFA] mt-20 overflow-hidden">
      {/* Curved top border with SVG */}
      <svg className="absolute top-0 left-0 w-full h-24" viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path
          d="M0,20 C240,0 1200,0 1440,20 L1440,100 L0,100 Z"
          fill="url(#footerGradient)"
          className="opacity-5"
        />
        <defs>
          <linearGradient id="footerGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#B18AE0" />
            <stop offset="50%" stopColor="#5B3FD0" />
            <stop offset="100%" stopColor="#9FFFCB" />
          </linearGradient>
        </defs>
      </svg>

      <div className="relative max-w-7xl mx-auto px-6 pt-20 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img src={LogoImage} alt="EduNasser Logo" className="w-16 h-16 object-contain" />
            </div>
            <p className="text-sm text-[#707070] leading-relaxed mb-6 max-w-sm">
              {t.footer.brand.description}
            </p>

            {/* Social links with modern design */}
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative w-11 h-11 rounded-xl bg-white border border-gray-200 flex items-center justify-center text-[#707070] hover:text-white hover:border-[#5B3FD0] transition-all overflow-hidden"
                  aria-label={social.name}
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-[#B18AE0] to-[#5B3FD0] translate-y-full group-hover:translate-y-0 transition-transform"></div>
                  <svg className="w-5 h-5 relative z-10" fill="currentColor" viewBox="0 0 24 24">
                    <path d={social.iconPath} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Product Column */}
          <div>
            <h5 className="text-sm font-bold text-[#2C2C2C] mb-5 flex items-center gap-2">
              <div className={`w-1 h-5 bg-gradient-to-b from-[#B18AE0] to-[#5B3FD0] rounded-full ${isRTL ? 'order-2' : ''}`}></div>
              {t.footer.sections.product.title}
            </h5>
            <ul className="space-y-3 text-sm text-[#707070]">
              {t.footer.sections.product.links.map((item) => (
                <li key={item}>
                  <a href="#" className="hover:text-[#5B3FD0] transition-colors inline-flex items-center gap-2 group">
                    <span className={`w-0 h-px bg-[#5B3FD0] group-hover:w-3 transition-all ${isRTL ? 'order-2' : ''}`}></span>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h5 className="text-sm font-bold text-[#2C2C2C] mb-5 flex items-center gap-2">
              <div className={`w-1 h-5 bg-gradient-to-b from-[#B18AE0] to-[#5B3FD0] rounded-full ${isRTL ? 'order-2' : ''}`}></div>
              {t.footer.sections.company.title}
            </h5>
            <ul className="space-y-3 text-sm text-[#707070]">
              {t.footer.sections.company.links.map((item) => (
                <li key={item}>
                  <a href="#" className="hover:text-[#5B3FD0] transition-colors inline-flex items-center gap-2 group">
                    <span className={`w-0 h-px bg-[#5B3FD0] group-hover:w-3 transition-all ${isRTL ? 'order-2' : ''}`}></span>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h5 className="text-sm font-bold text-[#2C2C2C] mb-5 flex items-center gap-2">
              <div className={`w-1 h-5 bg-gradient-to-b from-[#B18AE0] to-[#5B3FD0] rounded-full ${isRTL ? 'order-2' : ''}`}></div>
              {t.footer.sections.resources.title}
            </h5>
            <ul className="space-y-3 text-sm text-[#707070]">
              {t.footer.sections.resources.links.map((item) => (
                <li key={item}>
                  <a href="#" className="hover:text-[#5B3FD0] transition-colors inline-flex items-center gap-2 group">
                    <span className={`w-0 h-px bg-[#5B3FD0] group-hover:w-3 transition-all ${isRTL ? 'order-2' : ''}`}></span>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar with decorative line */}
        <div className="relative pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#707070]">
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <p className="flex items-center gap-2">
                © 2026 EduNasser. All rights reserved.
              </p>
              <div className="hidden sm:block w-px h-4 bg-gray-300"></div>
              <a
                href="https://bytelogs.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative inline-flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-[#5B3FD0] to-[#B18AE0] text-white text-xs font-medium rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300"
              >
                <span>Created by</span>
                <span className="font-bold">bytelogs.com</span>
                <svg className="w-3 h-3 group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              {t.footer.bottom.legal.map((item, index) => (
                <a
                  key={item}
                  href={`/legal/${['terms', 'privacy', 'cookies', 'licenses'][index]}`}
                  className="hover:text-[#5B3FD0] transition-colors text-xs sm:text-sm"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Decorative gradient orb */}
      <div className={`absolute bottom-0 ${isRTL ? 'left-0' : 'right-0'} w-96 h-96 bg-gradient-to-${isRTL ? 'tr' : 'tl'} from-[#B18AE0]/10 to-transparent rounded-full blur-3xl pointer-events-none`}></div>
    </footer>
  );
}
